import moment from 'moment';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

/**
 * Convert NgbDate to formatted string
 * @param date - NgbDate object from ng-bootstrap
 * @param format - Moment.js format string (default: 'MM/DD/YYYY')
 * @returns Formatted date string
 */
export function ngbDateToFormat(date: NgbDate, format: string = 'MM/DD/YYYY'): string {
  if (!date) {
    return '';
  }
  return moment(`${date.year}-${date.month}-${date.day}`, 'YYYY-MM-DD').format(format);
}

export function checkIndateFormatMessages(timestamp: moment.MomentInput): string {
  if (timestamp == undefined || timestamp == null || timestamp == '') {
    return '';
  }

  return moment.utc(timestamp).local().format('ddd, MMM DD, YYYY hh:mm A');
}
